// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Tag, Button } from 'antd';
import { CalendarOutlined, UserOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Meta } = Card;

const PostCard = ({ post, onDelete }) => {
  const isLoggedIn = localStorage.getItem('userToken');

  return (
    <Card
      hoverable
      className="post-card"
      cover={
        <div className="post-cover">
          <div className="cover-overlay">
            <div className="chinese-stamp">{post.tags[0] || '文物'}</div>
          </div>
        </div>
      }
      actions={[
        <Link to={`/post/${post.id}`}>
          <Button type="link" icon={<EyeOutlined />}>阅读全文</Button>
        </Link>,
        isLoggedIn && (
          <Button type="link" danger onClick={() => onDelete && onDelete(post.id)}>
            删除
          </Button>
        )
      ].filter(Boolean)}
    >
      <Meta
        title={<h3 className="post-title">{post.title}</h3>}
        description={
          <>
            <p className="post-summary">{post.summary}</p>
            <div className="post-meta">
              <span className="meta-item">
                <UserOutlined /> {post.author}
              </span>
              <span className="meta-item">
                <CalendarOutlined /> {post.date.split(' ')[0]}
              </span>
            </div>
            <div className="post-tags">
              {post.tags.map(tag => (
                <Tag key={tag} className="antique-tag">{tag}</Tag>
              ))}
            </div>
          </>
        }
      />
    </Card>
  );
};

export default PostCard;